import React, { useState, useEffect, useRef } from "react";
import Youtube from "../Assets/About/walking.mp4";

const mantras = [
  { id: 1, text: "Comparison kills creativity." },
  { id: 2, text: "Your brand, your story." },
  { id: 3, text: "Authenticity is power." },
  { id: 4, text: "Stand out, not blend in." },
  { id: 5, text: "Creativity starts within." },
];

const MantraSection = () => {
  const [currentMantraIndex, setCurrentMantraIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentMantraIndex((prevIndex) => (prevIndex + 1) % mantras.length);
        setIsTransitioning(false);
      }, 500);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.log("Video autoplay failed:", error);
      });
    }
  }, []);

  return (
    <div className="relative h-screen w-full overflow-hidden bg-gray-50">
      {/* Background video */}
      <video
        ref={videoRef}
        className="w-full h-full object-cover"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={Youtube} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Content container */}
      <div className="absolute inset-0 flex flex-col items-center">
        {/* Top heading */}
        <div className="w-full text-center mt-16">
          <p
            className="text-black text-4xl font-bold"
            style={{ fontFamily: "theimpressionist" }}
          >
            Your Daily Mantras
          </p>
        </div>

        {/* Center content */}
        <div className="flex-1 flex flex-col items-center justify-center">
          {/* Main mantra text */}
          <div className="text-center mb-4 mt-20">
            <h2
              className={`text-3xl md:text-4xl lg:text-5xl font-semibold text-black leading-tight transition-all duration-400 ease-in-out ${
                isTransitioning
                  ? "opacity-0 translate-y-4"
                  : "opacity-100 translate-y-0"
              }`}
              style={{
                fontFamily: "Blacker Pro Display",
              }}
            >
              {mantras[currentMantraIndex].text}
            </h2>
          </div>

          {/* Words to live by */}
          <p className="text-lg font-semibold uppercase tracking-widest text-black mt-4">
            WORDS TO LIVE BY
          </p>

          {/* Progress indicators */}
          <div className="mt-8 flex justify-center space-x-2">
            {mantras.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentMantraIndex(index)}
                className={`w-1 h-1 rounded-full transition-all duration-300 ${
                  index === currentMantraIndex ? "bg-black w-3" : "bg-white/30"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MantraSection;
